import React from 'react';
import { SettingsIcon, HeadsetMicIcon, InboxIcon, BarChartFilledIcon, HumaIntelligence40x40Icon } from '@econsult/econsult-ui/dist/assets';
import { useAppState } from 'store/configureStore';
import { STRINGS } from 'config';
import { StyledAppBarButton, StyledAppBar } from './styles';

export const AppBar: React.FC = () => {
  const { app: { selectedPracticeIsEhub } } = useAppState();
  if (selectedPracticeIsEhub) return null;

  return (
    <StyledAppBar data-automation="AppBar">
      <StyledAppBarButton
        label="Inbox"
        icon={<InboxIcon />}
        automationSuffix="Inbox"
        href={STRINGS.SMART_INBOX.HOST}
        target="_self"
      />
      <StyledAppBarButton
        label="eLite"
        icon={<HeadsetMicIcon />}
        automationSuffix="EconsultLite"
        href={STRINGS.E_LITE.HOST}
        target="_self"
      />
      <StyledAppBarButton
        label="Reporting"
        icon={<BarChartFilledIcon />}
        automationSuffix="Reporting"
        href={STRINGS.REPORTING.HOST}
        target="_self"
      />
      <StyledAppBarButton
        label="Scribe"
        icon={<HumaIntelligence40x40Icon />}
        automationSuffix="Scribe"
        href="/"
        target="_self"
      />
      <StyledAppBarButton
        label="Settings"
        icon={<SettingsIcon />}
        automationSuffix="Settings"
        href={`${STRINGS.SETTINGS.HOST}/?hideNav=true`}
        target="_self"
      />
    </StyledAppBar>
  );
};

export default AppBar;
